import './style.css';
import { initMap, updateMapData, toggleHeatmap, flyToReport } from './components/map.js';
import { initSidebarToggle, renderSidebar } from './components/sidebar.js';
import { initFilters, getActiveFilters } from './components/filters.js';
import { initReportModal, openModal } from './components/reportModal.js';
import { showToast } from './components/notifications.js';
import { fetchReports } from './services/reports.js';
import { debounce } from './utils/helpers.js';

// ── State ──
let allReports = [];
let mapAvailable = false;

// ── Bootstrap ──
async function init() {
  const token = import.meta.env.VITE_MAPBOX_TOKEN;
  const hasToken = token && !token.includes('YOUR_');

  // Always init sidebar toggle
  initSidebarToggle();

  // Always init filters
  initFilters(document.getElementById('filters-container'), handleFilterChange);

  // Always init report modal
  initReportModal(handleReportCreated, () => allReports);

  // Search input
  const searchInput = document.getElementById('search-input');
  searchInput.addEventListener('input', debounce(() => handleFilterChange(getActiveFilters()), 300));

  // Heatmap toggle
  document.getElementById('heatmap-toggle').addEventListener('click', (e) => {
    if (!mapAvailable) return;
    const active = toggleHeatmap();
    e.currentTarget.classList.toggle('active', active);
    showToast(active ? 'Тепловая карта включена' : 'Тепловая карта выключена', 'info', 2000);
  });

  // FAB → hint to click on map
  document.getElementById('fab-create').addEventListener('click', () => {
    if (!mapAvailable) {
      showToast('Карта не загружена — добавьте Mapbox токен', 'error');
      return;
    }
    showToast('Нажмите на любое место на карте, чтобы создать отчёт', 'info', 3000);
  });

  // Init map if token is available
  if (hasToken) {
    mapAvailable = true;
    initMap(token, handleMapClick);

    // Load reports after map loads
    const mapEl = document.getElementById('map');
    const observer = new MutationObserver(() => {
      if (document.querySelector('.mapboxgl-canvas')) {
        observer.disconnect();
        setTimeout(loadReports, 500);
      }
    });
    observer.observe(mapEl, { childList: true, subtree: true });
  } else {
    showToast('Добавьте Mapbox токен в .env файл', 'error', 6000);
    document.getElementById('loading-overlay')?.classList.add('hidden');
    await loadReports();
  }
}

// ── Data Loading ──
async function loadReports() {
  try {
    allReports = await fetchReports();
    if (mapAvailable) updateMapData(allReports);
    renderSidebar(allReports, handleCardClick);
  } catch (err) {
    console.error('Failed to load reports:', err);
    showToast('Ошибка загрузки данных', 'error');
  }
}

// ── Event Handlers ──
async function handleFilterChange(filters) {
  try {
    const reports = await fetchReports(filters);
    allReports = reports;
    if (mapAvailable) updateMapData(reports);
    renderSidebar(reports, handleCardClick);
  } catch (err) {
    console.error('Filter error:', err);
  }
}

function handleMapClick(latlng) {
  // Directly open modal on any map click — no "placing mode" needed
  openModal(latlng);
}

function handleReportCreated(report) {
  allReports.unshift(report);
  if (mapAvailable) updateMapData(allReports);
  renderSidebar(allReports, handleCardClick);
  if (mapAvailable) flyToReport(report);
}

function handleCardClick(report) {
  if (mapAvailable) flyToReport(report);
  if (window.innerWidth < 1024) {
    document.getElementById('sidebar').classList.remove('open');
    document.getElementById('sidebar-overlay').classList.remove('active');
  }
}

// ── Go! ──
init();
